

export interface CoreAppleSchoolManagerConfiguration {
    id: string
    moduleId: string
    sftpHostname?: string
    sftpUsername?: string
    sftpPassword?: string
    classSourceSelection: AppleSchoolManagerClassSource
    personIdMappingType: AppleSchoolManagerUserMappingType
    personIdMappingValue?: string
    personNumberMappingType: AppleSchoolManagerUserMappingType
    personNumberMappingValue?: string
    sisUserNameMappingType: AppleSchoolManagerUserMappingType
    sisUserNameMappingValue?: string
    emailAddressMappingType: AppleSchoolManagerUserMappingType
    emailAddressMappingValue?: string
    gradeLevelMappingType: AppleSchoolManagerGradeLevelMappingType
    activityInformationMarkingFilters?: string[]
}


export enum AppleSchoolManagerClassSource {
    NONE = 0x0000,
    CLASS = 0x0001,
    ACTIVITY = 0x0002,
}

export enum AppleSchoolManagerUserMappingType {
    DEFAULT = 0,
    ONPREMISESEXTENSIONATTRIBUTE = 1,
    GOOGLEID = 2,
    GOOGLEEMAIL = 3,
    FLOWSYNC_CIVICNO = 4,
    ENTRAIDUPN = 5,
}

export enum AppleSchoolManagerGradeLevelMappingType {
    UNDEFINED = 0,
    STANDARD = 1,
    UNIQUE = 2,
}

export const classSourceSelectionOptions: AppleSchoolManagerClassSource[] = [
    AppleSchoolManagerClassSource.CLASS,
    AppleSchoolManagerClassSource.ACTIVITY,
];

export const gradeLevelMappingOptions: AppleSchoolManagerGradeLevelMappingType[] = [
    AppleSchoolManagerGradeLevelMappingType.STANDARD,
    AppleSchoolManagerGradeLevelMappingType.UNIQUE,
];

export const userMappingTypes: AppleSchoolManagerUserMappingType[] = [
    AppleSchoolManagerUserMappingType.DEFAULT,
    AppleSchoolManagerUserMappingType.ONPREMISESEXTENSIONATTRIBUTE,
    AppleSchoolManagerUserMappingType.GOOGLEID,
    AppleSchoolManagerUserMappingType.GOOGLEEMAIL,
    AppleSchoolManagerUserMappingType.FLOWSYNC_CIVICNO,
    AppleSchoolManagerUserMappingType.ENTRAIDUPN,
];

export const ExtensionAttributes: Array<string> = [
    "extensionAttribute1",
    "extensionAttribute2",
    "extensionAttribute3",
    "extensionAttribute4",
    "extensionAttribute5",
    "extensionAttribute6",
    "extensionAttribute7",
    "extensionAttribute8",
    "extensionAttribute9",
    "extensionAttribute10",
    "extensionAttribute11",
    "extensionAttribute12",
    "extensionAttribute13",
    "extensionAttribute14",
    "extensionAttribute15",
];
